var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { List } from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import EmptyCoupon from './EmptyCoupon';
import betTypeFactory from './betTypeFactory';
import { addRateCoupon as addRateCouponAction, clearBetSlips as clearBetSlipsAction, acceptChange as acceptChangeAction, selectBetType as selectBetTypeAction, deleteBetSlip as deleteBetSlipAction, saveBetType as saveBetTypeAction } from '../../actions/coupon/creators/coupon';
import { cancelBigStakeBetSlip as cancelBigStakeBetSlipAction } from '../../actions/creators/BigStakeRequest';
import { getFreebet as getFreebetAction } from '../../actions/auth/creators/SignIn';
import { makeBet as makeBetAction, makeMultiSingleBet as makeMultiSingleBetAction } from '../../actions/creators/makeBet';
import BetTypes from './betSlip/BetTypes';
import * as BetTypesMap from '../../constants/BetType';
import * as BetStatus from '../../constants/BetStatus';
import { rateFactorChangeConfirmNeeded, isRateUnavailable } from './rateUtils';
import { createBetModel, transformBetSlip, createMultiSingleBetModel, getSelectedFreebet } from './utils';
import QuickBetSuccess from './quickbet/QuickBetSuccess';
import Error from './quickbet/QuickBetError';
import FreebetButton from './FreebetButton';
import { resourceNames as resources, resourceNames } from '../../constants/accountResourceNames';
import { defineMessages, FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { maxWinAmount as MaxBetAmountValues } from '../../constants/StakeMaxWinAmount';
import { minAmount as MinAmountValues } from '../../constants/StakeMinAmount';
import { openAuthModal as openAuthModalAction } from '../../actions/auth/creators/Login';
import { CLEAR_CASHE_FREEBET } from '../../actions/coupon/coupon';
import localeMap from '../../constants/Locale';
var messages = defineMessages({
    coupon_clear: {
        id: 'coupon.clear',
        defaultMessage: '<span class="button__hint-top">нажмите еще раз чтобы</span><span class="button__hint-bottom">Clear</span>'
    },
    coupon_betslip_question: {
        id: 'coupon.betslip_question',
        defaultMessage: '<span class="button__hint-top">нажмите еще раз чтобы</span><span class="button__hint-bottom">Очистить весь купон</span>'
    },
    coupon_close: {
        id: 'coupon.close',
        defaultMessage: 'Свернуть'
    },
    coupon_coefficient_changed: {
        id: 'coupon.coefficient_changed',
        defaultMessage: 'Odd has changed!'
    },
    coupon_accept_changes: {
        id: 'coupon.accept_changes',
        defaultMessage: 'Accept Changes'
    },
    coupon_make_bet: {
        id: 'coupon.make_bet',
        defaultMessage: 'Place Bet'
    },
    coupon_make_bet_stake: {
        id: 'coupon.make_bet_stake',
        defaultMessage: 'ставку',
    },
    coupon_make_bet_stakes: {
        id: 'coupon.make_bet_stakes',
        defaultMessage: '{count} ставки',
    },
    coupon_cancel_big_bet: {
        id: 'coupon.cancel_big_bet',
        defaultMessage: 'Отменить крупную ставку',
    },
    coupon_your_balance: {
        id: 'coupon.your_balance',
        defaultMessage: 'Your Balance'
    },
    coupon_impossible: {
        id: 'coupon.impossible',
        defaultMessage: 'Cannot place bet. Chosen outcomes are incompatible.'
    },
    coupon_clear_bin: {
        id: 'coupon.clear_bin',
        defaultMessage: 'Clear betslip and try choosing another outcomes.'
    },
    enter_bet_amount: {
        id: 'coupon.enter_bet_amount',
        defaultMessage: 'Введите сумму ставки!',
    }
});
var BetSlipList = /** @class */ (function (_super) {
    __extends(BetSlipList, _super);
    function BetSlipList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            prompt: false,
            showSuccessModal: true,
            freebetToggled: false,
            selectedFreebetId: undefined
        };
        _this.selectFreebet = function (selectedFreebetId) {
            _this.setState({ selectedFreebetId: selectedFreebetId });
        };
        _this.makeBet = function (makeBetAction, amount, user, betType, rank, isFreebet, factors, bettingMode, freebetId) {
            if (isFreebet === void 0) { isFreebet = false; }
            if (amount <= 0) {
                alert(_this.props.intl.formatMessage(messages.enter_bet_amount));
                return false;
            }
            var lang = localeMap[_this.props.languageId];
            makeBetAction(createBetModel(amount, user, betType, rank, isFreebet, factors, bettingMode, lang, freebetId));
        };
        _this.makeMultiSingleBet = function (makeBetAction, amount, user, betType, rank, isFreebet, factors, bettingMode, freebetId) {
            if (isFreebet === void 0) { isFreebet = false; }
            if (amount <= 0) {
                alert(_this.props.intl.formatMessage(messages.enter_bet_amount));
                return false;
            }
            var lang = localeMap[_this.props.languageId];
            makeBetAction(createMultiSingleBetModel(amount, user, betType, rank, isFreebet, factors, bettingMode, lang, freebetId));
        };
        _this.closeSuccessModal = function () {
            _this.setState({
                showSuccessModal: false
            });
            _this.props.close();
            _this.props.getFreebetAction();
        };
        _this.clearMultiSingle = function () {
            _this.setState({
                showSuccessModal: false
            });
            _this.props.close();
            _this.props.clearBetSlipsAction();
        };
        _this.makeFreebetClick = function (e) {
            e.preventDefault();
            var _a = _this.props, user = _a.user, betSlips = _a.betSlips, freebets = _a.freebets, selectedBetType = _a.selectedBetType, bettingMode = _a.bettingMode;
            var freebet = getSelectedFreebet(freebets, _this.state.selectedFreebetId);
            var betType = selectedBetType.betType;
            var rank = selectedBetType.rank || null;
            _this.makeBet(_this.props.makeBetAction, freebet.amount, user, betType, rank, true, BetSlipList.transform(betSlips), bettingMode, freebet.id);
        };
        _this.makeBetClick = function (e) {
            e.preventDefault();
            var _a = _this.props, couponAmount = _a.couponAmount, user = _a.user, betSlips = _a.betSlips, selectedBetType = _a.selectedBetType, couponStatus = _a.couponStatus, bettingMode = _a.bettingMode;
            var betType = selectedBetType.betType;
            var rank = selectedBetType.rank || null;
            var status = couponStatus.get('status');
            var bets = couponStatus.get('bets');
            var isBigStake = status === BetStatus.STAKE_REQUEST;
            if (bets.size > 0 && bets.find(function (f) { return f.get('status') === BetStatus.STAKE_REQUEST; })) {
                isBigStake = true;
            }
            var savedCouponAmount = couponAmount > 0 ? couponAmount : Number(localStorage.getItem('couponAmountValue'));
            if (!isBigStake) {
                if (betSlips.size > 1 && betType === 1) {
                    _this.makeMultiSingleBet(_this.props.makeMultiSingleBetAction, savedCouponAmount, user, betType, rank, false, BetSlipList.transform(betSlips), bettingMode);
                }
                else {
                    _this.makeBet(_this.props.makeBetAction, savedCouponAmount, user, betType, rank, false, BetSlipList.transform(betSlips), bettingMode);
                }
            }
        };
        _this.acceptFactorChangesClick = function (changedRates, e) {
            e.preventDefault();
            _this.props.acceptChangeAction(changedRates);
        };
        _this.clearBetSlips = function () {
            _this.props.close();
            _this.props.clearBetSlipsAction();
            localStorage.setItem('couponAmountValue', '');
        };
        _this.betSlipsPromptOpen = function () {
            var prompt = true;
            if (_this.props.betSlips.size === 1) {
                _this.props.close();
                _this.props.clearBetSlipsAction();
                prompt = false;
            }
            _this.setState({
                prompt: prompt
            });
            localStorage.setItem('couponAmountValue', '');
        };
        _this.betSlipsPromptClose = function () {
            _this.setState({
                prompt: false,
            });
        };
        _this.toggleFreebet = function () {
            _this.setState({
                freebetToggled: !_this.state.freebetToggled
            });
        };
        _this.disableFreebet = function () {
            _this.setState({
                freebetToggled: false
            });
        };
        _this.deleteBetSlip = function (id) {
            _this.props.deleteBetSlipAction(id);
            if (_this.props.betSlips.size === 1) {
                _this.props.close();
            }
            _this.props.clearCacheFreebetAction();
        };
        _this.closeModal = function () {
            var couponStatus = _this.props.couponStatus;
            var loading = couponStatus.get('loading');
            var bets = couponStatus.get('bets');
            var status = couponStatus.get('status');
            var isBigStake = status === BetStatus.STAKE_REQUEST;
            if (bets.size > 0 && bets.find(function (f) { return f.get('status') === BetStatus.STAKE_REQUEST; })) {
                isBigStake = true;
            }
            var isLoading = isModalIsLoading(loading, status, bets);
            if (isLoading === false && !isBigStake) {
                _this.props.close();
            }
        };
        _this.onCancelBigStakeRequest = function () {
            var _a = _this.props, user = _a.user, couponStatus = _a.couponStatus;
            var gamblerId = user.gamblerId;
            var stakeId = couponStatus.get('stakeId');
            _this.props.cancelBigStakeBetSlipAction({ gamblerId: gamblerId, stakeId: stakeId });
        };
        return _this;
    }
    BetSlipList.transform = function (rates) {
        var transformedRates = new List();
        rates.valueSeq().forEach(function (rate) {
            transformedRates = transformedRates.push(transformBetSlip(rate));
        });
        return transformedRates;
    };
    BetSlipList.prototype.renderClear = function () {
        var prompt = this.state.prompt;
        var darkTheme = this.props.darkTheme;
        var svgName = darkTheme ? 'dark-clear-betslip.svg' : 'clear-betslip.svg';
        return (_jsx(Fragment, { children: !prompt
                ? _jsxs("button", __assign({ onClick: this.betSlipsPromptOpen, className: 'clear-btn clear-btn--first', style: { top: '-2px' } }, { children: [_jsx("img", { src: require("./../../assets/img/".concat(svgName)), alt: '' }), _jsx(FormattedHTMLMessage, __assign({}, messages.coupon_clear))] }))
                : _jsxs("button", __assign({ onClick: this.clearBetSlips, className: 'clear-btn', style: { top: '-2px' } }, { children: [_jsx("img", { src: require("./../../assets/img/".concat(svgName)), alt: '' }), _jsx(FormattedHTMLMessage, __assign({}, messages.coupon_betslip_question))] })) }));
    };
    BetSlipList.prototype.render = function () {
        var _a = this.props, selectBetTypeAction = _a.selectBetTypeAction, close = _a.close, betSlips = _a.betSlips, betTypes = _a.betTypes, gridLocalization = _a.gridLocalization, couponAmount = _a.couponAmount, selectedBetType = _a.selectedBetType, couponStatus = _a.couponStatus, freebets = _a.freebets, user = _a.user, freebetErrors = _a.freebetErrors;
        var _b = this.state, freebetToggled = _b.freebetToggled, selectedFreebetId = _b.selectedFreebetId;
        var freebet = getSelectedFreebet(freebets, selectedFreebetId);
        var bettingAvailable = true;
        var errorCode = couponStatus.get('betCreateError');
        var alternativeStake = couponStatus.get('alternativeStake');
        if (couponStatus.get('status') === undefined) {
            return false;
        }
        var isLoading = false;
        var status = couponStatus.get('status');
        var loading = couponStatus.get('loading');
        var bets = couponStatus.get('bets');
        var isBigStake = status === BetStatus.STAKE_REQUEST;
        if (bets.size > 0 && bets.find(function (f) { return f.get('status') === BetStatus.STAKE_REQUEST; })) {
            isBigStake = true;
        }
        if ((status === BetStatus.CONFIRMED)) {
            return (_jsx(QuickBetSuccess, { closeModal: this.closeSuccessModal, show: this.state.showSuccessModal }));
        }
        if (bets.size > 0 && !bets.find(function (f) { return f.get('status') !== BetStatus.CONFIRMED; })) {
            return (_jsx(QuickBetSuccess, { closeModal: this.clearMultiSingle, show: this.state.showSuccessModal }));
        }
        var renderContent = _jsx(EmptyCoupon, { close: this.props.close });
        var showError = '';
        if (errorCode !== undefined || status === BetStatus.REJECTED) {
            var errorProps = {
                user: user,
                alternativeStake: alternativeStake,
                errorCode: errorCode || status,
                accountResourceId: user.accountResourceId,
                resolution: couponStatus.get('resolution'),
                limit: couponStatus.get('limit') || 0
            };
            showError = _jsx(Error, __assign({}, errorProps));
        }
        if (betSlips.size > 0) {
            var betType = selectedBetType.betType;
            var Renderer = betTypeFactory(betType);
            var changedFactorRates_1 = [];
            betSlips.forEach(function (r) {
                var rate = r.get('rate');
                var id = rate.get('id');
                var actualValue = rate.get('actualValue');
                if (rateFactorChangeConfirmNeeded(rate)) {
                    changedFactorRates_1.push({ id: id, actualValue: actualValue });
                }
                if (isRateUnavailable(rate)) {
                    bettingAvailable = false;
                }
            });
            var betBtnCls = bettingAvailable ? '' : 'betting-unavailable';
            isLoading = loading || status === BetStatus.CONFIRM_AWAIT || status === BetStatus.IN_DELAY;
            if (bets.size > 0 && bets.find(function (f) { return f.get('status') === BetStatus.CONFIRM_AWAIT || f.get('status') === BetStatus.IN_DELAY || f.get('status') === BetStatus.CONFIRM_AWAIT; })) {
                isLoading = true;
            }
            var ifMaxBetAvailable = getPossibleWin(selectedBetType, betTypes, couponAmount, betSlips, MaxBetAmountValues[resourceNames[user.accountResourceId]]);
            if (couponAmount > 0 && couponAmount < MinAmountValues[resources[user.accountResourceId]]) {
                var errorProps = {
                    user: user,
                    errorCode: 6,
                    accountResourceId: user.accountResourceId,
                    resolution: couponStatus.get('resolution'),
                    minBetAmount: MinAmountValues[resources[user.accountResourceId]]
                };
                bettingAvailable = false;
                showError = _jsx(Error, __assign({}, errorProps));
            }
            if (couponAmount > this.props.balance && user && user.accountId) {
                var errorProps = {
                    user: user,
                    errorCode: 111,
                };
                bettingAvailable = false;
                showError = _jsx(Error, __assign({}, errorProps));
            }
            if (ifMaxBetAvailable) {
                var errorProps = {
                    user: user,
                    errorCode: 7,
                    accountResourceId: user.accountResourceId,
                    resolution: couponStatus.get('resolution'),
                    maxWinAmount: MaxBetAmountValues[resourceNames[user.accountResourceId]]
                };
                bettingAvailable = false;
                showError = _jsx(Error, __assign({}, errorProps));
            }
            if (freebetErrors) {
                var errorProps = {
                    user: user,
                    accountResourceId: user.accountResourceId,
                    resolution: couponStatus.get('resolution'),
                    freebetErrors: freebetErrors
                };
                bettingAvailable = false;
                showError = _jsx(Error, __assign({}, errorProps));
            }
            if (bets.size > 0) {
                var limitError = bets.find(function (bet) { return bet.get('errorCode') === -19 && bet.get('limit') && bet.get('limit') > 0; });
                if (limitError) {
                    var errorProps = {
                        user: user,
                        errorCode: -19,
                        limit: limitError.get('limit'),
                        accountResourceId: user.accountResourceId,
                        resolution: couponStatus.get('resolution')
                    };
                    bettingAvailable = false;
                    showError = _jsx(Error, __assign({}, errorProps));
                }
            }
            if (user.accountResourceId === undefined) {
                bettingAvailable = false;
            }
            var click = freebetToggled ? this.makeFreebetClick : this.makeBetClick;
            var intl = this.props.intl;
            var makeBetBtnTitle = intl.formatMessage(messages.coupon_make_bet_stake);
            var showFreebet = freebets.length > 0;
            if (selectedBetType.betType === BetTypesMap.SINGLE && betSlips.size > 1) {
                click = this.makeBetClick;
                makeBetBtnTitle = intl.formatMessage(messages.coupon_make_bet_stakes, { count: betSlips.size });
                showFreebet = false;
            }
            var renderMakeBetBtn = (_jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ type: 'button', disabled: !bettingAvailable || isLoading, className: "".concat(betBtnCls, " ").concat(isLoading ? 'loading' : ''), onClick: click }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_make_bet, { values: { title: makeBetBtnTitle } })) })) })));
            if (changedFactorRates_1.length > 0 && !isLoading) {
                var boundConfirmClick = this.acceptFactorChangesClick.bind(this, changedFactorRates_1);
                renderMakeBetBtn = (_jsx("div", __assign({ className: 'controls accepted' }, { children: _jsx("button", __assign({ type: 'button', id: 'acceptchanges', onClick: boundConfirmClick }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_accept_changes)) })) })));
            }
            var isAuthenticated = user.accountResourceId !== undefined;
            if (!isAuthenticated) {
                renderMakeBetBtn = (_jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ type: 'button', className: '', onClick: this.props.openAuthModalAction }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_make_bet, { values: { title: makeBetBtnTitle } })) })) })));
            }
            if (isBigStake) {
                renderMakeBetBtn = (_jsxs("div", __assign({ className: 'controls cancel_big_stake', onClick: this.onCancelBigStakeRequest }, { children: [_jsx("button", { className: 'loading' }), _jsx("div", __assign({ style: { marginTop: '2px', cursor: 'pointer' } }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_cancel_big_bet)) }))] })));
            }
            var accountResourceId = user.accountResourceId;
            var accountResourceName = resourceNames[accountResourceId];
            var freebetProps = {
                freebetToggled: freebetToggled,
                freebets: freebets,
                selectedFreebetId: freebet.id,
                accountResourceName: accountResourceName,
                toggleFreebet: this.toggleFreebet,
                selectFreebet: this.selectFreebet
            };
            var props = {
                disableFreebet: this.disableFreebet,
                freebet: freebet,
                freebetToggled: freebetToggled,
                gridLocalization: gridLocalization,
                betSlips: betSlips,
                couponAmount: couponAmount,
                selectedBetType: selectedBetType,
                prompt: this.state.prompt,
                betSlipsPromptClose: this.betSlipsPromptClose,
                deleteBetSlipAction: this.deleteBetSlip,
                errorCode: errorCode || status,
                status: status,
                showError: showError
            };
            var darkTheme = this.props.darkTheme;
            var svgName = darkTheme ? 'dark-hide-betslips.svg' : 'hide-betslips.svg';
            renderContent = (_jsxs("div", __assign({ id: 'coupon_content' }, { children: [_jsx(BetTypes, { betTypes: betTypes, saveBetTypeAction: this.props.saveBetTypeAction, selectedBetType: selectedBetType, selectBetTypeAction: selectBetTypeAction, betSlipsSize: betSlips.size }), _jsxs("div", __assign({ className: 'new-betslips__coupon' }, { children: [_jsx(Renderer, __assign({}, props)), showFreebet && _jsx(FreebetButton, __assign({}, freebetProps)), renderMakeBetBtn, _jsxs("div", __assign({ className: 'coupon__controls' }, { children: [this.renderClear(), _jsxs("button", __assign({ onClick: close }, { children: [_jsx("img", { src: require("./../../assets/img/".concat(svgName)), alt: '' }), _jsx(FormattedMessage, __assign({}, messages.coupon_close))] }))] }))] }))] })));
        }
        var modalContentCls = isLoading ? ' modal-is-loading' : '';
        return (_jsxs("div", __assign({ className: 'new-betslips active', id: 'azim' }, { children: [_jsx("div", { className: 'new-betslips__overlay', onClick: this.closeModal, id: 'overlay' }), _jsx("div", __assign({ className: "new-betslips__content".concat(modalContentCls) }, { children: renderContent }))] })));
    };
    return BetSlipList;
}(React.Component));
function isModalIsLoading(loading, status, bets) {
    var isLoading = loading || status === BetStatus.CONFIRM_AWAIT || status === BetStatus.IN_DELAY || status === BetStatus.CONFIRM_AWAIT;
    if (bets.size > 0 && bets.find(function (f) { return f.get('status') === BetStatus.CONFIRM_AWAIT || f.get('status') === BetStatus.IN_DELAY || f.get('status') === BetStatus.CONFIRM_AWAIT; })) {
        isLoading = true;
    }
    return isLoading;
}
function getPossibleWin(selectedBetType, betTypes, couponAmount, betSlips, maxBetValue) {
    if (selectedBetType.betType === BetTypesMap.EXPRESS || selectedBetType.betType === BetTypesMap.ANTIEXPRESS) {
        var odd = 0;
        var betTypeFind = betTypes.find(function (b) {
            return b.type === selectedBetType.betType;
        });
        if (betTypeFind) {
            odd = betTypeFind.odd;
        }
        var possibleWinAmount = Math.ceil((odd * couponAmount) * 1000) / 1000;
        return possibleWinAmount > maxBetValue;
    }
    else if (selectedBetType.betType === BetTypesMap.SINGLE) {
        var ifAvailable_1 = false;
        betSlips.map(function (bet) {
            var rate = bet.get('rate');
            var value = rate.get('value');
            var actualValue = rate.get('actualValue');
            var possibleWinAmount = actualValue ? Math.ceil((actualValue * couponAmount) * 1000) / 1000 : Math.ceil((value * couponAmount) * 1000) / 1000;
            if (possibleWinAmount > maxBetValue) {
                ifAvailable_1 = true;
            }
        });
        return ifAvailable_1;
    }
    else if (selectedBetType.betType === BetTypesMap.SYSTEM) {
        var systemVariants = betTypes.filter(function (b) {
            return b.type === selectedBetType.betType;
        }).toArray();
        var rank_1 = selectedBetType.rank;
        var selectedItem = systemVariants.find(function (item) { return item.rank === rank_1; });
        var odd = 0;
        if (selectedItem !== undefined) {
            odd = selectedItem.odd;
        }
        var possibleWinAmount = Math.ceil((odd * couponAmount) * 1000) / 1000;
        return possibleWinAmount > maxBetValue;
    }
    return false;
}
BetSlipList.propTypes = {
    selectedBetType: PropTypes.object.isRequired,
    couponAmount: PropTypes.any.isRequired,
    user: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
    betSlipModalToggled: PropTypes.bool.isRequired,
    betSlips: PropTypes.object.isRequired,
    betTypes: PropTypes.object.isRequired,
    bettingMode: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    selectBetTypeAction: PropTypes.func.isRequired,
    addRateCouponAction: PropTypes.func.isRequired,
    clearBetSlipsAction: PropTypes.func.isRequired,
    acceptChangeAction: PropTypes.func.isRequired,
    openAuthModalAction: PropTypes.func.isRequired,
    makeBetAction: PropTypes.func.isRequired,
    makeMultiSingleBetAction: PropTypes.func.isRequired,
    deleteBetSlipAction: PropTypes.func.isRequired,
    couponStatus: PropTypes.object.isRequired,
    balance: PropTypes.number.isRequired,
    freebets: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired
};
var mapStateToProps = function (state) {
    return {
        betSlips: state.coupon.get('betSlips'),
        betTypes: state.coupon.get('betTypes'),
        couponAmount: state.coupon.get('couponAmount'),
        couponStatus: state.coupon.get('couponStatus'),
        quickBet: state.coupon.get('quickBet'),
        user: state.auth.user,
        selectedBetType: state.coupon.get('selectedBetType'),
        balance: state.balance.value,
        freebets: state.auth.freebets,
        bettingMode: state.application.get('bettingMode'),
        darkTheme: state.application.get('darkTheme'),
        freebetErrors: state.coupon.get('couponStatus').get('freebetErrors'),
        languageId: state.application.get('languageId')
    };
};
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    addRateCouponAction: addRateCouponAction,
    clearBetSlipsAction: clearBetSlipsAction,
    acceptChangeAction: acceptChangeAction,
    makeBetAction: makeBetAction,
    makeMultiSingleBetAction: makeMultiSingleBetAction,
    selectBetTypeAction: selectBetTypeAction,
    deleteBetSlipAction: deleteBetSlipAction,
    getFreebetAction: getFreebetAction,
    cancelBigStakeBetSlipAction: cancelBigStakeBetSlipAction,
    openAuthModalAction: openAuthModalAction,
    saveBetTypeAction: saveBetTypeAction,
    clearCacheFreebetAction: function () { return dispatch({ type: CLEAR_CASHE_FREEBET }); }
}, dispatch); };
BetSlipList = connect(mapStateToProps, mapDispatchToProps)(BetSlipList);
export default injectIntl(BetSlipList);



// WEBPACK FOOTER //
// ./src/components/coupon/BetSlipList.jsx